/* @jsxImportSource @emotion/react */
/* eslint-disable formatjs/no-literal-string-in-jsx */

import { css } from '@emotion/react'

import { SliteLogo, SuperSourceIcon } from '@slite/components'
import {
  CaretDownIcon,
  ClockIcon,
  CommentsEmptyIcon,
  MoreIcon,
} from '@slite/icons'
import { SuperSource } from '@slite/search-client'

import intercomAvatar from './assets/intercom-avatar.png'
import { TrafficDots } from './TrafficDots'

const rootCss = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #7FD1FE;
  font-size: 12.5px;
  color: #1d1c1d;
  border: 4px solid #7FD1FE;
  border-radius: 16px;
  overflow: hidden;
`

function CustomerAvatar() {
  return (
    <img
      src={intercomAvatar}
      alt=""
      className="flexbox-no-shrink"
      style={{
        width: 26,
        height: 26,
        borderRadius: '50%',
        objectFit: 'cover',
        border: '2px solid #FFF',
      }}
    />
  )
}

export function IntercomInterface() {
  return (
    <div css={rootCss} aria-hidden>
      <div
        className="flexbox flexbox-align-end position-relative flexbox-no-shrink"
        style={{ padding: '0 10px' }}
      >
        <div
          className="position-absolute"
          style={{ left: 14, top: 0, bottom: 0, display: 'flex' }}
        >
          <TrafficDots color="rgba(255, 255, 255, 0.65)" />
        </div>
        <div
          className="flexbox flexbox-align-center flexbox-gap-6 margin-right-auto"
          style={{
            background: '#FFF',
            borderRadius: '8px 8px 0 0',
            padding: '7px 16px',
            marginLeft: 64,
          }}
        >
          <SuperSourceIcon sourceType={SuperSource.INTERCOM} size={14} />
          <span className="font-weight-medium">Intercom</span>
        </div>
      </div>
      <div
        className="flexbox flexbox-column flexbox-grow"
        style={{
          margin: '0 0px',
          background: '#FFF',
          borderRadius: '10px',
          minHeight: 0,
          justifyContent: 'flex-end',
          overflow: 'hidden',
          borderTop: '6px solid #FFF',
        }}
      >
        <div
          className="flexbox flexbox-align-end flexbox-gap-8"
          style={{ padding: 14 }}
        >
          <div
            style={{
              background: '#D6EBFC',
              borderRadius: 12,
              padding: '12px 14px',
              lineHeight: 1.5,
            }}
          >
            Sorry about that! I see your order #56789 is a merino sweater. This
            needs a team member's approval, so I'll transfer you now.
            <div
              className="text-align-right"
              style={{ fontSize: 11, color: '#7A8A99', marginTop: 4 }}
            >
              Seen • 1mo
            </div>
          </div>
          <CustomerAvatar />
        </div>
        <div
          style={{
            margin: '0 4px 4px',
            border: '1px solid #E5E5E5',
            borderRadius: 10,
            padding: '10px 12px',
          }}
        >
          <div className="flexbox flexbox-align-center flexbox-gap-6">
            <CommentsEmptyIcon size={14} />
            <span className="font-weight-medium">Reply</span>
            <CaretDownIcon size={12} className="shade-40" />
          </div>
          <div style={{ color: '#8A8A8A', marginTop: 10 }}>
            Use ⌘K for shortcuts
          </div>
          <div
            className="flexbox flexbox-align-center flexbox-space-between"
            style={{ marginTop: 16 }}
          >
            <div
              className="flexbox flexbox-align-center flexbox-gap-8"
              style={{ color: '#8A8A8A' }}
            >
              <ClockIcon size={14} />
              <span style={{ width: 1, height: 14, background: '#E5E5E5' }} />
              <MoreIcon size={14} />
            </div>
            <div className="flexbox flexbox-align-center flexbox-gap-8">
              <span
                className="flexbox flexbox-align-center"
                style={{
                  border: '1px solid #DDDDDD',
                  borderRadius: 8,
                  fontWeight: 500,
                }}
              >
                <span style={{ padding: '4px 10px' }}>Send</span>
                <span
                  className="flexbox flexbox-centered"
                  style={{
                    padding: '4px 6px',
                    borderLeft: '1px solid #DDDDDD',
                  }}
                >
                  <CaretDownIcon size={12} className="shade-40" />
                </span>
              </span>
              <SliteLogo
                variant="symbol"
                style={{ width: 26, height: 26, flexShrink: 0 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
